import { Component } from '@nicolas-riciotti/light2';
import { isMobilePortrait } from '../../helpers/isMobile';
import getPosition from '../../helpers/getPosition';
const TOUCH = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0);


export default class BlockParallaxFloat extends Component {

    created() {
        this.angle = -Math.PI/2;
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onPointerMove  = this.onPointerMove.bind(this);
        this.mouseObj = { x: 0, y: 0 };
        this.mouseObj.x = 0;
        this.mouseObj.y = 0;

        let p = getPosition(this);
        this._top = p.top;
        this._left = p.left;
    }

    onPointerMove(event) {

        const touchEvent  = TOUCH && event.touches ? (event.touches[0] || event.changedTouches[0]) : event;
        this.mouseObj.x = touchEvent.pageX - this._left;
        this.mouseObj.y = touchEvent.pageY - this._top;
    }
    
    resize() {
        let p = getPosition(this);
        this._top = p.top;
        this._left = p.left;

        this._width  = this.clientWidth;
        this._height = this.clientHeight;
        this.$slides.forEach((el,i) => {
            el._currX  = 0;
            el._currY  = 0;
            el._rand   = Math.random();
            el._rand2  = Math.random();
        });
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    detached() {
        document.removeEventListener('site_settings_motion', this.siteSettingsMotionChange);
        this._io?.disconnect();
    }

    attached() {
        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);
        this.$slides =this.querySelectorAll('[data-slide]');
        this.$slides.forEach((el,i) => {
            el._rand = Math.random();
            el._depth = el._rand; // 0 = near (in focus), 1 = far (back)

            // Everything below is derived purely from depth, which never
            // changes after attach. Bake it once here instead of recomputing
            // and re-writing it on every animation frame.
            const depth = el._depth;
            el._z     = (1 - depth) * 300 - depth * 600;  // front comes forward, back pushes away
            el._scale = 1 - depth * 0.18;
            // Blur is the dominant GPU cost: cap the max radius (was *8) and
            // drop the filter entirely on near-front layers where a sub-pixel
            // blur is imperceptible but still forces a compositing layer.
            const blurPx = depth * 6;
            el.style.filter = blurPx < 0.6 ? 'none' : `blur(${blurPx}px)`;
            el.style.zIndex = String(Math.round((1 - depth) * 1000));
        });

        // Enable z-axis depth on the host so per-layer translateZ/scale read
        // as actual perspective rather than flat 2D.
        this.style.perspective = '1400px';
        this.style.perspectiveOrigin = '50% 50%';
        this.style.transformStyle = 'preserve-3d';

        this.resize();


        this._inView = false;
        let rendered = false;
        this._io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this._inView = entry.isIntersecting;
                if (entry.isIntersecting && !rendered) {
                    rendered = true;
                    document.addEventListener('mousemove', this.onPointerMove, false);
                }
            }
        }, {
            rootMargin: '200px 0px',
            threshold: 0,
        });
        this._io.observe(this);

    }

    update() {

        if ( !this._inView ) {
            return;
        }

        if (window.innerWidth < 600) {
            return;
        }

        this.$slides.forEach((el,i) => {
            const depth = el._depth;                     // 0 = front, 1 = back
            const parallax = 0.02 + 0.18 * (1 - depth);  // front layers move more
            const x = this.mouseObj.x * parallax;
            const y = this.mouseObj.y * parallax;
            el._currX += (x - el._currX) * 0.05;
            el._currY += (y - el._currY) * 0.05;

            // Only the eased translate changes per frame; z/scale/blur/zIndex
            // are baked once in attached().
            if (this.stopped) {
                el.style.transform = `none`;
            }
            else {
                el.style.transform = `translate3d(${el._currX}px, ${el._currY}px, ${el._z}px) scale(${el._scale})`;
            }
        });

    }
}

customElements.define('block-parallax-float', BlockParallaxFloat);
